var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginPageLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 159.425,
    viewBox: "0 0 386.391 159.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EDU-04",
    transform: "translate(-11.25 -629.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M1036.545,831.806v27.958l.071,6.26.107,3.13.107,3.13h-.319l-1.849-3.984-1.849-3.948q-2.207-4.66-3.877-7.932L1016.309,831.8h-15.615v48.553h9.213V852.506l-.071-6.367-.107-3.166-.143-3.2h.355l1.53,3.487,1.566,3.487q2.207,4.981,3.237,6.971l13.873,26.642h15.615V831.806h-9.213Zm-75.136,32.44,8.252-25.29,8.394,25.29Zm21.875,16.113h9.568l-16.4-48.553H962.617l-16.149,48.553h9.746l3.023-9.32h20.951Zm-56.036-9.639q-2.881,2.169-7.968,2.17-9.994,0-11.9-2.028t-1.9-12.7q0-14.119,1.566-16.505t10.848-2.383q7.79,0,10,1.9t2.206,8.7v10.92q0,.891-.286,3.522l-10.032-6.793-3.841,5.548,11.31,7.647Zm11.241-.355q.961-3.949.962-14.94,0-15.473-3.86-19.759t-17.8-4.286c-9.295,0-15.408,1.518-17.91,4.553s-3.753,10.279-3.753,21.732q0,14.761,3.948,18.94t17.857,4.179q12.7,0,17.215-4.589l4.624,3.2,3.806-5.548-5.086-3.487ZM890.135,840.06v-8.252H852.4v8.252H866.41v40.3h9.213v-40.3Zm-55.325,40.3h9.213V831.808H834.81Z",
    transform: "translate(-649.249 -159.266)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M266.363,823.22a45.572,45.572,0,0,0,.661-7.677c0-24.565-19.57-44.48-43.71-44.48s-43.71,19.915-43.71,44.48,19.568,44.48,43.71,44.48a42.886,42.886,0,0,0,21.023-5.488,43.877,43.877,0,0,0,7.771-5.56c.4.3.8.607,1.192.912,5.89,4.518,11.8,9.115,18.1,13.054l.076.047a68.058,68.058,0,0,1-6.616,6.1,66.023,66.023,0,0,1-41.546,14.683c-33.021,0-60.465-24.292-66.024-56.269a11.782,11.782,0,0,0,1.7-.857l.034-.021a15.772,15.772,0,0,0,4.2-3.358,8.323,8.323,0,0,0,1.723-6.212,11.928,11.928,0,0,0-1.673-5.2,9.561,9.561,0,0,0-3.663-3.851c-.856-.449-.972-.765-.907-1.547a4.817,4.817,0,0,0-1.262-3.706s0,0-.006-.007a68.273,68.273,0,0,1,1.772-7.277l4.41,3.608.888-.331a67.34,67.34,0,0,0,37.541-40l.285-.891-4.414-5.483a65.808,65.808,0,0,1,25.393-5.065c37.031,0,67.05,30.55,67.05,68.233a69.634,69.634,0,0,1-1.673,15.209C280.92,828.554,273.386,825.92,266.363,823.22Z",
    transform: "translate(-115.384 -94.841)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M376.685,1099.337c-40.9-16.764-59.955.376-59.955.376,27.406-7.674,44.892,4.914,62.539,18.214,5.89,4.44,11.8,8.957,18.1,12.828,9.958,6.119,20.9,10.619,34.3,10.628,55.014.036,61.511-52.573,61.511-52.573-27,43.179-82.04,24.652-116.5,10.529h0Z",
    transform: "translate(-240.914 -362.295)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M444.392,874.36s-6.335,6.121-7.792,7.727-2.584,4.175,0,7c4.876,5.321,6.262,7.288,6.043,9.4,0,0,7.223-6.486,8.243-7.362s3.5-3.352.437-6.413a57.806,57.806,0,0,1-5.838-6.486,4.893,4.893,0,0,1-1.094-3.862",
    transform: "translate(-334.496 -193.227)",
    fill: "#ed4c16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M444.392,980.61s-6.335,6.121-7.792,7.725-2.584,4.177,0,7c4.876,5.321,6.262,7.288,6.043,9.4,0,0,7.223-6.486,8.243-7.361s3.5-3.352.437-6.415a57.627,57.627,0,0,1-5.838-6.486,4.893,4.893,0,0,1-1.094-3.862",
    transform: "translate(-334.496 -277.075)",
    fill: "#ed4c16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M1809.218,1224.31v.529c-.082.008-.153.025-.227.025q-4.509,0-9.018.006c-.223,0-.351-.073-.275-.56h9.518Z",
    transform: "translate(-1411.576 -469.477)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M1136.427,1224.31v.529c-.082.008-.153.025-.227.025q-4.509,0-9.018.006c-.222,0-.35-.073-.275-.56h9.517Z",
    transform: "translate(-880.555 -469.477)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(264.925 747.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M1222.38,1199.953v1.625h-9.49V1188.5h9.23v1.625h-7.361v4.018h6.558v1.589h-6.558v4.223h7.622Z",
    transform: "translate(-1212.89 -1188.351)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M1272.51,1188.5h5.512c4.2,0,7.062,2.653,7.062,6.539s-2.859,6.539-7.062,6.539h-5.512Zm5.4,11.453c3.232,0,5.306-1.979,5.306-4.914s-2.074-4.914-5.306-4.914h-3.531v9.828Z",
    transform: "translate(-1259.995 -1188.351)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M1345.482,1195.945v-7.435h1.868v7.362c0,2.9,1.327,4.2,3.68,4.2s3.7-1.308,3.7-4.2v-7.362h1.811v7.435c0,3.793-2.074,5.792-5.529,5.792s-5.531-2-5.531-5.792Z",
    transform: "translate(-1317.648 -1188.359)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M1411.35,1194.478a6.615,6.615,0,0,1,6.931-6.688,6.458,6.458,0,0,1,4.969,2.036l-1.215,1.178a4.849,4.849,0,0,0-3.68-1.551,5.026,5.026,0,1,0,0,10.05,4.856,4.856,0,0,0,3.68-1.57l1.215,1.178a6.488,6.488,0,0,1-4.987,2.055A6.61,6.61,0,0,1,1411.35,1194.478Z",
    transform: "translate(-1369.691 -1187.79)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M1480.143,1198.317h-6.95l-1.438,3.271h-1.925l5.922-13.078h1.849l5.94,13.078h-1.963l-1.438-3.271Zm-.653-1.494-2.821-6.409-2.821,6.409Z",
    transform: "translate(-1415.895 -1188.359)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M1536.794,1190.135h-4.484v-1.625h10.817v1.625h-4.484v11.453h-1.849Z",
    transform: "translate(-1465.26 -1188.359)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M1593.54,1188.5h1.868v13.078h-1.868Z",
    transform: "translate(-1513.637 -1188.351)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M1616.05,1194.478a6.955,6.955,0,1,1,6.969,6.688A6.646,6.646,0,0,1,1616.05,1194.478Zm12.032,0a5.082,5.082,0,1,0-5.063,5.025A4.909,4.909,0,0,0,1628.082,1194.478Z",
    transform: "translate(-1531.422 -1187.79)",
    fill: "#21827f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M1707.137,1188.5v13.078H1705.6l-7.847-9.753v9.753h-1.868V1188.5h1.532l7.846,9.752V1188.5Z",
    transform: "translate(-1594.502 -1188.351)",
    fill: "#21827f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(11.25 629.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M88.647,629.819c-2.036,1.144-4.077,2.278-6.09,3.464-2.129,1.253-4.219,2.569-6.341,3.833-1.134.674-2.3,1.3-3.455,1.933-.521.286-1.075.508-1.583.81-.964.577-1.889,1.222-2.861,1.784-1.539.892-3.117,1.715-4.652,2.613-2.874,1.688-5.724,3.413-8.59,5.111-2.338,1.385-4.689,2.75-7.03,4.131-.88.519-1.734,1.077-2.622,1.581-1.545.877-3.132,1.681-4.645,2.609a5.128,5.128,0,0,0-1.545,1.505c-.844,1.276-1.574,2.628-2.338,3.955-1.8,3.128-3.587,6.266-5.393,9.391-1.329,2.3-2.674,4.591-4.016,6.885-1.369,2.338-2.767,4.66-4.106,7.015-1.9,3.346-3.762,6.717-5.651,10.074-.382.68-.821,1.327-1.22,2-1.039,1.755-2.089,3.506-3.1,5.279-.751,1.325-1.444,2.685-2.164,4.028l.164.178a3.471,3.471,0,0,0,.642-.229q2.805-1.653,5.6-3.323,2.881-1.722,5.754-3.453c1.379-.833,2.737-1.707,4.133-2.515a1.555,1.555,0,0,1,1.052-.153c.139.036.2.55.229.852.176,1.633.258,3.279.518,4.9a18.755,18.755,0,0,0,1.005,3.98c.6,1.492,1.474,2.874,2.21,4.312a1.318,1.318,0,0,1,.122.684c-.073.794-.262,1.583-.269,2.374a2.339,2.339,0,0,0,2.37,2.592,3.222,3.222,0,0,1,3.6,2.364,17.3,17.3,0,0,1,1.373,4.612,19.149,19.149,0,0,1-.907,6.432c-.229.829-.08,1.039.737.772a16.461,16.461,0,0,0,3.474-1.425,14.255,14.255,0,0,0,3.81-2.953,6.4,6.4,0,0,0,1.348-4.885,9.946,9.946,0,0,0-1.436-4.387,7.872,7.872,0,0,0-3-3.166,2.887,2.887,0,0,1-1.812-3.157,2.987,2.987,0,0,0-3.149-3.268c-1.774.069-3.128-.208-3.783-2.059a29.787,29.787,0,0,1-1.574-4.2,24.006,24.006,0,0,1-.2-4.935c.031-1.656-.141-3.371.819-4.885a1.735,1.735,0,0,0,.111-.388,47.391,47.391,0,0,1,1.772-5.334,51.318,51.318,0,0,1,3.2-5.6c1.28-2.055,2.609-4.087,4.016-6.058,1.675-2.347,3.44-4.629,5.2-6.914a13.128,13.128,0,0,1,1.331-1.314c.1.071.208.145.313.216a4.731,4.731,0,0,1-.5,1.043c-.976,1.188-2.072,2.284-2.977,3.52-1.734,2.372-3.419,4.784-5.025,7.244a52.331,52.331,0,0,0-2.823,4.967c-.68,1.337-1.2,2.758-1.759,4.154q-.812,2.025-1.555,4.077a4.523,4.523,0,0,0-.1,1.064,3.244,3.244,0,0,0,.684-.172l.835-.483,1.847-1.066,22.857-13.189.938-1.644,16.193-28.351c.176-.29.348-.577.518-.869s.342-.613.506-.924l.017-.034,2.477-4.335c.491-.827.98-1.654,1.459-2.49.132-.231.254-.47.369-.712l2.416-4.232c.936-1.5,1.881-2.989,2.809-4.492a5.62,5.62,0,0,0,.355-1.045,6.043,6.043,0,0,0-.926.309Z",
    transform: "translate(-11.25 -629.51)",
    fill: "#ed4c16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M163.537,773.706,139.97,788.259l.458.68,10.143,8.157s27.278-9.948,36.518-38.252l-8.6-10.5-14.948,25.368Z",
    transform: "translate(-112.95 -723.396)",
    fill: "#ed4c16"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageLogo);
export default __webpack_public_path__ + "static/media/login-page-logo.65383fc0d214aa8c2a8443d53ef9fcbc.svg";
export { ForwardRef as ReactComponent };